import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';
import type { SavedSearchCadence } from '@/types/savedSearch';

const KADENCJE: SavedSearchCadence[] = ['instant', 'daily', 'weekly'];

/**
 * Trzy kadencje e-maili o nowych ofertach (natychmiast · codziennie · raz w tygodniu, plan §1.34).
 * Jedno miejsce dla jednorazowego pytania po pierwszym zapisie (C3, `PytanieOMaile`) i pola
 * „Wysyłaj mi e-mailem…” na kroku „Czego szukasz?” (C5) — te same etykiety, ten sam wygląd.
 * Ustawienia (C6, §1.64) pokazują karty z opisem (`zOpisem`) i wyszarzają je, gdy e-maile są
 * wyłączone (`wylaczony`): wybór zostaje, ale nie da się go zmienić (makieta `settings-moje-filtry`).
 */
export function WyborKadencji({
  wartosc,
  onChange,
  etykieta,
  className,
  zOpisem = false,
  wylaczony = false,
}: {
  wartosc: SavedSearchCadence;
  onChange: (k: SavedSearchCadence) => void;
  /** Nazwa grupy dla czytnika ekranu. */
  etykieta: string;
  className?: string;
  /** Karta: nazwa + jedno zdanie opisu (Ustawienia). */
  zOpisem?: boolean;
  wylaczony?: boolean;
}) {
  const { t } = useTranslation();
  return (
    <div
      role="radiogroup"
      aria-label={etykieta}
      aria-disabled={wylaczony || undefined}
      className={cn('grid gap-1.5', wylaczony && 'opacity-50', className)}
    >
      {KADENCJE.map((k) => {
        const wybrana = k === wartosc;
        return (
          <button
            key={k}
            type="button"
            role="radio"
            aria-checked={wybrana}
            data-testid={`kadencja-${k}`}
            disabled={wylaczony}
            onClick={() => onChange(k)}
            className={cn(
              'flex items-center gap-2.5 rounded-lg border px-3 py-2.5 text-left text-base transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed md:text-sm',
              wybrana ? 'border-primary bg-primary/10' : 'border-border',
              !wybrana && !wylaczony && 'hover:bg-muted',
            )}
          >
            <span
              aria-hidden
              className={cn(
                'flex h-4 w-4 shrink-0 items-center justify-center rounded-full border-2',
                wybrana ? 'border-primary' : 'border-border',
              )}
            >
              {wybrana && <span className="h-1.5 w-1.5 rounded-full bg-primary" />}
            </span>
            {zOpisem ? (
              <span className="flex flex-col">
                <span className="font-semibold">{t(`settings.flat_alerts.cadence_${k}_title`)}</span>
                <span className="text-sm text-muted-foreground md:text-xs">{t(`settings.flat_alerts.cadence_${k}_desc`)}</span>
              </span>
            ) : (
              t(`search.my_filters.mail.${k}`)
            )}
          </button>
        );
      })}
    </div>
  );
}

export default WyborKadencji;
